import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery, takeLatest, call, put, select, all } from 'redux-saga/effects';

import * as Api from 'api';


/***************************** Selectors ************************************/
const getUser = state => (state.connection.user);
const getIncidents = state => (state.client_incidents);

/***************************** Subroutines ************************************/
function* updateIncidentSuccess(action) {
  try {
    yield put(Actions.updateIncident(action.payload.incident));
  } catch (ex) {
    yield putError(action, ex);
  }
}

function* fetchIncidents(action) {
  try {
    const state = yield select(getIncidents);

    const requestOptions = {
      size: state.size,
      offset: 0,
      client: action.payload.client
    }

    const incidents = yield call(Api.fetchIncidents, requestOptions);

    yield put(Actions.receiveIncidents(incidents));

  } catch (ex) {
    yield putError(action, ex);
  }
}

function* fetchRecentImpactsSuccess(action) {
  try {
    const impacts = yield call(Api.fetchClientRecentImpacts, action.payload.id);
    yield put(Actions.receiveRecentImpacts(impacts));
  } catch (ex) {
    yield putError(action, ex);
  }
}

function* fetchIncident(action) {
  try {
    const incident = yield call(Api.fetchIncident, action.payload.id);
    yield put(Actions.updateIncident(incident));
  } catch (ex) {
    yield putError(action, ex);
  }
}

function* newIncidentSuccess(action) {
  try {
    yield put(Actions.addIncident(action.payload.incident));

    const user = yield select(getUser);

    if (user._id == action.payload.incident.creator) {
      yield put(Actions.previewIncident(action.payload.incident));
      yield put(Actions.hideCreateIncident());
    }

  } catch (ex) {
    yield putError(action, ex);
  }
}

function* newIncidentFailed(action) {
  yield put(Actions.notify({
    title: 'Error Creating Incident',
    message: action.payload.message
  }));
}

function* fetchRecentImpactsFailed(action) {
  yield put(Actions.notify({
    title: 'Error Loading Recent Impacts',
    message: action.payload.message
  }));
}

function* updateIncidentFailed(action) {
  yield put(Actions.notify({
    title: 'Error Updating Incident',
    message: action.payload.message
  }));
}

function* fetchIncidentsFailed(action) {
  yield put(Actions.notify({
    title: 'Error Loading Incidents',
    message: action.payload.message
  }));
}

function * generateReport() {
  try {
    yield put(Actions.toggleGeneratingReport(true))
    let {incidents, selected_incident} = yield select(getIncidents)
    let current_incident = incidents.find(i => i._id === selected_incident)
    let files = current_incident.adjuster_report_pdfs.filter(r => r.selected).map(r => ({_id : r.file._id, idx : r.idx}))

    let report_link = yield call(Api.generateReport, {incident : current_incident, files})
    yield put(Actions.toggleGeneratingReport(false))

    yield put(Actions.promptNewReportDownload(report_link))
  }
  catch(ex) {
    yield put(Actions.toggleGeneratingReport(false))
    yield put(Actions.notify({message : ex}))
  }
}

function * deleteReportsPDFS() {
  try {
    yield put(Actions.toggleDeletingReportPDFS(true))

    let incidents = yield select(getIncidents)
    let {selected_incident} = incidents;
    let files = incidents.incidents.find(i => i._id === selected_incident).adjuster_report_pdfs;
    let selected_files = files.filter(f => f.selected).map(f => f.file._id)
    let updated_incident = yield call(Api.deleteReportPDFs, selected_incident, selected_files)

    yield put(Actions.deleteReportPDFS())
    yield put(Actions.toggleDeletingReportPDFS(false))
  }
  catch(e) {
    console.error(e)
    yield put(Actions.toggleDeletingReportPDFS(false))
    yield put(Actions.notify({message: e.message || e}))
  }
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* newImpactWatcher() {
  yield [
    takeEvery(ActionTypes.CLIENT_INCIDENT_NEW_SUCCESS, newIncidentSuccess),
    takeEvery(ActionTypes.CLIENT_INCIDENT_NEW_FAILED, newIncidentFailed)
  ];
}

export function* incidentWatchers() {
  yield all([
    takeEvery(ActionTypes.FETCH_CLIENT_RECENT_IMPACTS, fetchRecentImpactsSuccess),
    takeEvery(ActionTypes.FETCH_CLIENT_RECENT_IMPACTS_FAILED, fetchRecentImpactsFailed),
    takeEvery(ActionTypes.FETCH_CLIENT_INCIDENT, fetchIncident),
    takeEvery(ActionTypes.FETCH_CLIENT_INCIDENTS, fetchIncidents),
    takeEvery(ActionTypes.FETCH_CLIENT_INCIDENTS_FAILED, fetchIncidentsFailed),
    takeEvery(ActionTypes.CLIENT_INCIDENT_EDIT_FAILED, updateIncidentFailed),
    takeEvery(ActionTypes.CLIENT_INCIDENT_EDIT_SUCCESS, updateIncidentSuccess),
    takeEvery(ActionTypes.GENERATE_INCIDENT_REPORT, generateReport),
    takeEvery(ActionTypes.BEGIN_DELETE_REPORT_PDFS, deleteReportsPDFS)
  ])
}

function* putError(action, ex) {
  yield put({ type: `${action.type}_FAILED`, payload: ex });
}



// WEBPACK FOOTER //
// ./src/common/sagas/client_incidents.js